import React, { lazy, useMemo } from "react"

import { useCore } from "../../hooks/useCore"
import { useAccount } from "../../hooks/useAccount"
import { Locked } from "../Locked/Locked"

export const withSections = Component => ({ name = "Sections", page, ...props }) => {
  const {
    helpers: { handleize, ErrorBoundary, isBrowser },
  } = useCore()
  const { activeSubscription, profile } = useAccount()

  const locked = useMemo(() => ("members" === page?.visibility && !profile) || ("subscribed" === page?.visibility && !activeSubscription), [
    activeSubscription,
    page?.visibility,
    profile,
  ])

  const sections = page?.content?.map((section: any, index: number) => {
    const name = section?._type?.replace("section", "")
    const id = `${handleize(name)}-${index}`

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const SectionComponent = isBrowser ? lazy(() => import(`./${name}/${name}`)) : require(`./${name}/${name}`).default

    return {
      ...section,
      component: () => (
        <ErrorBoundary>
          <SectionComponent {...props} {...section} id={id} />
        </ErrorBoundary>
      ),
    }
  })

  Component.displayName = name
  return locked ? <Locked {...props} /> : <Component {...props} content={sections} />
}
